import React, { useEffect, useState } from 'react';
import { useParams, useSearchParams } from 'react-router-dom';
import { Button } from 'components/buttons/buttons';
import { useTranslation } from 'react-i18next';
import { PageHeader } from 'components/page-headers/page-headers';
import FeatherIcon from 'feather-icons-react';
import { Main } from 'container/styled';
import { TableWrapper } from 'container/styled';
import { Cards } from 'components/cards/frame/cards-frame';
import { CustomTableStyleWrapper } from 'pages/style';
import { ContractorPaymentsTable } from './components/ContractorPaymentsTable';
import { ContractorDetailsDto, ContractorProjectDetailsDto } from 'api/models';
import { ContractorsApi } from 'api/api';

export const ContractorPaymentsPage = () => {
  const { contractorId } = useParams<{ contractorId: string }>();
  const [searchParams] = useSearchParams();
  const projectId = searchParams.get('projectId');
  const contractorsApi = new ContractorsApi();
  const [contractor, setContractor] = useState<ContractorDetailsDto>();
  const [loading, setLoading] = useState(false);
  const { t } = useTranslation();

  const fetchContractor = async () => {
    if (!contractorId) return;
    try {
      setLoading(true);
      const response = await contractorsApi.apiContractorsIdGet({ id: parseInt(contractorId) });
      setContractor(response.data);
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchContractor();
  }, [contractorId]);

  return (
    <>
      <PageHeader ghost title={t('payments:contractor-payments', 'Contractor Payments')} />
      <Main>
        <Cards headless loading={loading}>
          <CustomTableStyleWrapper>
            <TableWrapper>
              <ContractorPaymentsTable
                contractorId={parseInt(contractorId!)}
                onPaymentChange={fetchContractor}
                projectId={projectId ? parseInt(projectId) : undefined}
                projects={contractor?.projects ?? []}
              />
            </TableWrapper>
          </CustomTableStyleWrapper>
        </Cards>
      </Main>
    </>
  );
};
